import { useSyncExternalStore } from 'react';

export default function useMediaQuery(query: string) {
  const subscribe = (callback: () => void) => {
    const mediaQuery = window.matchMedia(query);
    mediaQuery.addEventListener('change', callback);

    return () => {
      mediaQuery.removeEventListener('change', callback);
    };
  };

  const getSnapshot = () => {
    return window.matchMedia(query).matches;
  };

  return useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => false, // SSR fallback
  );
}
